import EditorField from 'builder/components/EditorField'
import { AcquisitionDatePicker } from 'builder/components/DocumentEditor/Japanese/Cards/CoursesCard/AcquisitionDatePicker'
import { useLanguageCardContext } from '../../ExpandableCardContext'
import { useShokumuTranslations } from '../../useShokumuTranslations'

const CertificateDate = (): JSX.Element => {
  const { item, onCardValueChange } = useLanguageCardContext()
  const acquisitionDatePickerValue = {
    dateUntil: item.certificateAcquisitionDate,
  }

  const { i18n } = useShokumuTranslations()
  const label = i18n('languages.certificate_date')

  return (
    <EditorField>
      <AcquisitionDatePicker
        value={acquisitionDatePickerValue}
        onChange={value => {
          onCardValueChange({ certificateAcquisitionDate: value.dateUntil }, true)
        }}
        headingLabel={label}
        showLabelHint={false}
      />
    </EditorField>
  )
}
export default CertificateDate
